<template>
    <div class="container-row">
        &copy; 2018 XXX | Privacy | Contact us
    </div>
</template>

<script>
export default {
  name: 'FooterContainer'
}
</script>

<style scoped>
.container-row {
    background-color: #000;
    color: #fff;
    font-size: .8rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Containers/FooterContainer.vue